import * as React from 'react';

import { observer } from 'mobx-react';

import { useTranslation } from '~utils/hooks/translations';

import { CenterMessageView } from './common/CenterMessageView';

export const PageNotLoaded = observer(() => {
    const { genericError } = useTranslation();

    return <CenterMessageView data-test-id="IAM_PAGE_NOT_LOADED">{genericError}</CenterMessageView>;
});
